import { networkCall } from "../../../../../utils/network-call/network-call";

export const AdminUserAddLoader = async () => {
    const getCompaniesResponse = await networkCall('/companies');
    return { getCompaniesResponse };
};